import { Link } from "react-router-dom";
import { ArrowRight, Dumbbell, Target, Timer, Calendar } from "lucide-react";

const PILLARS = [
  {
    icon: Dumbbell,
    h: "Tailored Programmes",
    b: "Strength, conditioning, mobility and mindset work built around your goals, your schedule and the equipment you have.",
  },
  {
    icon: Target,
    h: "Resilience-First",
    b: "Every programme is rooted in DTA's Down · Test · Adjust framework. Build the body alongside the mindset.",
  },
  {
    icon: Timer,
    h: "Weekly Check-Ins",
    b: "Short reviews each week. Honest reflection, small adjustments and the confidence to keep going.",
  },
  {
    icon: Calendar,
    h: "30 Day · 3 · 6 · 12 Month",
    b: "Start with a 30-day foundation. Move into longer programmes as the standard becomes the habit.",
  },
];

export default function PersonalTraining() {
  return (
    <div className="bg-[#F4F3EF]">
      {/* Hero */}
      <section className="relative bg-[#0A0A0A] text-white grain overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://customer-assets-jt897jd0.emergentagent.net/job_down-test-adjust/artifacts/wz8z1qhp_ChatGPT%20Image%20Jul%2025%2C%202026%20at%2002_29_03%20PM.png"
            alt="DTA training"
            className="w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/90" />
        </div>
        <div className="relative dta-container pt-32 pb-24 md:pb-32">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 px-3 py-1.5 mb-8">
            <span className="w-1.5 h-1.5 bg-[#8fa8d6] rounded-full animate-pulse" />
            <span className="dta-overline text-[0.6rem] text-white/80">
              Launching soon. Join the waiting list
            </span>
          </div>
          <p className="dta-overline text-white/60">Personal Training</p>
          <h1 className="hero-headline text-5xl md:text-8xl mt-6 max-w-4xl">
            Train the body.<br />
            <span className="text-[#8fa8d6]">Train the mind.</span>
          </h1>
          <p className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed">
            DTA Personal Training is a resilience-first programme, tailored to your goals, built around the Down. Test. Adjust. principle, and designed to be sustainable long after motivation fades.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/" className="dta-btn dta-btn-primary">
              Join the waiting list <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
            <Link to="/about" className="dta-btn dta-btn-outline-light">
              Read our story
            </Link>
          </div>
        </div>
      </section>

      {/* Pillars */}
      <section className="py-24 md:py-32 border-b border-black/10">
        <div className="dta-container">
          <p className="dta-overline text-navy">What&apos;s included</p>
          <h2 className="section-heading text-4xl md:text-6xl mt-3 max-w-3xl">
            Four pillars.<br />One standard.
          </h2>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {PILLARS.map((p) => {
              const Icon = p.icon;
              return (
                <div key={p.h} className="border-t border-black/10 pt-6 flex gap-5">
                  <Icon className="w-6 h-6 text-[#031D47] mt-1 shrink-0" strokeWidth={1.5} />
                  <div>
                    <h3 className="font-display uppercase font-bold text-2xl md:text-3xl text-[#0A0A0A]">
                      {p.h}
                    </h3>
                    <p className="text-base text-[#272727] mt-3 leading-relaxed">{p.b}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 bg-[#0A0A0A] text-white">
        <div className="dta-container flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <p className="dta-overline text-white/50">Be first</p>
            <h2 className="section-heading text-3xl md:text-5xl mt-2">
              Join the waiting list.
            </h2>
            <p className="text-white/60 mt-3 max-w-md">
              The 30-day foundation programme launches first. Limited places on the opening cohort.
            </p>
          </div>
          <Link to="/" className="dta-btn dta-btn-primary">
            Add me to the list <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>
      </section>
    </div>
  );
}
